/* eslint-disable max-len */
export default {
    modal: {
        actEnd: {
            title: 'Promotion Ended',
            desc: 'View the latest offers in Promotions.',
            btn: 'Go'
        },
        noCrowd: {
            title: 'This promotion is for <br/>new users only.',
            desc: 'Find out more promotions',
            btn: 'Go'
        }
    },
    message: {
        sendSuccess: 'Congratulations!\n Reward received'
    }
};
